import type { IconName } from '~/chords';
import { Icon } from '~/components';
import { cn } from '~/lib/cn';

interface ErrorStateProps {
  title: string;
  description?: string;
  iconType?: IconName;
  className?: string;
}

export function ErrorDisplay({
  title,
  description,
  iconType = 'info-circle',
  className,
}: ErrorStateProps): React.ReactNode {
  return (
    <div
      data-testid="error-display"
      className={cn(
        'flex justify-center rounded-xs p-lg bg-level-02',
        className,
      )}
    >
      <div className="flex w-full items-center justify-center rounded-xs border border-dashed py-lg border-emphasis-subtle">
        <div className="text-center">
          <p className="text-body-md text-error-default">
            <Icon type={iconType} variant="light" size="4x" />
          </p>
          <p className="mb-sm mt-lg text-body-lg font-semibold text-default">
            {title}
          </p>
          {description ? (
            <p className="text-body-md text-subtle">{description}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

ErrorDisplay.displayName = 'ErrorDisplay';
